import { SVGProps } from "react";

export const BookmarkFilled = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 14 18" fill="currentColor" {...props}>
      <path d="M1.5618e-07 2.24995V17.4371C-7.39594e-05 17.5348 0.0262319 17.6308 0.0763287 17.7157C0.126425 17.8006 0.198586 17.8714 0.285707 17.9213C0.372828 17.9711 0.471906 17.9982 0.573189 17.9999C0.674472 18.0016 0.774468 17.9779 0.863333 17.931L7 14.7023L13.1367 17.931C13.2255 17.9779 13.3255 18.0016 13.4268 17.9999C13.5281 17.9982 13.6272 17.9711 13.7143 17.9213C13.8014 17.8714 13.8736 17.8006 13.9237 17.7157C13.9738 17.6308 14.0001 17.5348 14 17.4371V2.24995C14 1.65323 13.7542 1.08094 13.3166 0.658995C12.879 0.237048 12.2855 0 11.6667 0L2.33333 0C1.7145 0 1.121 0.237048 0.683418 0.658995C0.245833 1.08094 1.5618e-07 1.65323 1.5618e-07 2.24995V2.24995Z" />
    </svg>
  );
};
